/* Detailing1 Paket D6 (2026-09): Trusted-Shops-Produktsterne auf Karten und Schnellbestell-Zeilen — ohne das
   eTrusted-Widget je Karte. Das Widget lud pro Instanz Manifest, Konfiguration, Sprachdatei, Kanal-Feed und
   Versionsabfrage (5 Requests) plus einen Grades-Feed je SKU: 12 Karten = 346 Requests je Seitenaufruf.
   Hier: je SKU genau ein kleines JSON (grades.overall), dedupliziert über die Seite, 6 h im localStorage,
   nur für Karten in Sichtweite (IntersectionObserver), max. 6 parallel. Mehrere SKUs je Karte werden
   nach Anzahl gewichtet gemittelt — wie das Widget mit data-sku="a, b, c".
   Quelle: <div class="d1-rating" data-skus="SKU1, SKU2"> (snippets/product-card.liquid, d1-quick-order-row.liquid). */
(function () {
  if (window.D1Ratings) return;
  const CHANNEL = 'chl-d66d090f-5fa9-4cbb-a006-3c667999fc08';
  const TTL = 6 * 60 * 60 * 1000;
  const MAX_PARALLEL = 6;
  const mem = new Map();
  const queue = [];
  let active = 0;

  const hex = (s) => Array.from(new TextEncoder().encode(s)).map((b) => b.toString(16).padStart(2, '0')).join('');
  const store = {
    get(sku) {
      try {
        const v = JSON.parse(localStorage.getItem(`d1-ts:${sku}`));
        if (v && Date.now() - v.t < TTL) return v.g;
      } catch (e) { /* kein Storage */ }
      return null;
    },
    set(sku, g) { try { localStorage.setItem(`d1-ts:${sku}`, JSON.stringify({ t: Date.now(), g })); } catch (e) { /* voll/gesperrt */ } }
  };
  const pump = () => {
    while (active < MAX_PARALLEL && queue.length) {
      const job = queue.shift();
      active += 1;
      job().finally(() => { active -= 1; pump(); });
    }
  };
  const grade = (sku) => {
    if (mem.has(sku)) return mem.get(sku);
    const cached = store.get(sku);
    if (cached) { const p = Promise.resolve(cached); mem.set(sku, p); return p; }
    const p = new Promise((resolve) => {
      queue.push(() => fetch(`https://integrations.etrusted.com/feeds/grades/v1/channels/${CHANNEL}/products/sku/${hex(sku)}/feed.json`)
        .then((r) => {
          if (!r.ok) throw new Error(`Ratings request failed: ${r.status}`);
          return r.json();
        })
        .then((j) => {
          const o = j && j.grades && j.grades.overall;
          const g = o && o.count ? { r: Number(o.rating) || 0, c: Number(o.count) || 0 } : { r: 0, c: 0 };
          store.set(sku, g);
          resolve(g);
        })
        .catch(() => { mem.delete(sku); resolve({ r: 0, c: 0 }); }));
    });
    mem.set(sku, p);
    pump();
    return p;
  };

  const lang = (document.documentElement.lang || 'de').slice(0, 2);
  const fmt = new Intl.NumberFormat(lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const render = (el, r, c) => {
    // Ohne Bewertungen: fünf leere Sterne (wie das Widget), keine Zahlen
    if (!c) {
      el.innerHTML = '<span class="d1-rating__stars" aria-hidden="true"><span class="d1-rating__fill" style="width:0%"></span></span>';
      el.dataset.d1RatingState = 'empty';
      return;
    }
    const pct = Math.max(0, Math.min(100, (r / 5) * 100));
    el.innerHTML = `<span class="d1-rating__stars" aria-hidden="true"><span class="d1-rating__fill" style="width:${pct.toFixed(1)}%"></span></span>`
      + `<span class="d1-rating__num">${fmt.format(r)}</span><span class="d1-rating__count">(${c})</span>`;
    el.setAttribute('role', 'img');
    el.setAttribute('aria-label', `${fmt.format(r)} / 5 (${c})`);
    el.dataset.d1RatingState = 'done';
    if (el.classList.contains('d1-rating--banner')) richSnippet(r, c);
  };
  // Rich Snippet (AggregateRating) der Collection — kam bisher vom Trusted-Shops-Listenwidget (isRichSnippetEnabled),
  // das jetzt erst beim Scrollen geladen wird. Einmal je Seite, aus denselben Werten wie der Banner (alle SKUs).
  const richSnippet = (r, c) => {
    if (document.getElementById('d1-rating-ldjson')) return;
    const h1 = document.querySelector('h1');
    const data = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: (h1 ? h1.textContent : document.title).trim().replace(/\s+/g, ' '),
      url: window.location.origin + window.location.pathname,
      aggregateRating: { '@type': 'AggregateRating', ratingValue: r.toFixed(2), reviewCount: String(c), bestRating: '5', worstRating: '1' }
    };
    const s = document.createElement('script');
    s.type = 'application/ld+json';
    s.id = 'd1-rating-ldjson';
    s.textContent = JSON.stringify(data);
    document.head.appendChild(s);
  };
  const fill = async (el) => {
    if (el.dataset.d1RatingState) return;
    el.dataset.d1RatingState = 'loading';
    const skus = Array.from(new Set((el.dataset.skus || '').split(',').map((s) => s.trim()).filter(Boolean)));
    if (!skus.length) { render(el, 0, 0); return; }
    const gs = await Promise.all(skus.map(grade));
    if (el.dataset.aggregate === 'sum') {
      // Alle Varianten zusammen (nach Anzahl gewichtet) — zeigt mehr Bewertungen, weicht aber vom PDP-Widget ab
      let c = 0; let sum = 0;
      gs.forEach((g) => { c += g.c; sum += g.r * g.c; });
      render(el, c ? sum / c : 0, c);
      return;
    }
    // Standard = Verhalten des eTrusted-Widgets mit mehreren SKUs: die erste SKU (in Reihenfolge) mit Bewertungen zählt.
    // Belegt an tuga-chemie: Alu-Teufel 4,67 (3) = AS5D, Aluminium-Teufel 5,00 (1) = AT1D (AT5D mit 2 weiteren bleibt außen vor).
    const first = gs.find((g) => g.c > 0) || { r: 0, c: 0 };
    render(el, first.r, first.c);
  };

  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); fill(e.target); } }), { rootMargin: '400px 0px' })
    : null;
  // Paket D6b: eTrusted-Widgets unterhalb des sichtbaren Bereichs (Bewertungsliste auf Collections) erst einhängen,
  // wenn sie in die Nähe scrollen. Markup aus den Templates: <div class="d1-ts-lazy"><template>…<etrusted-widget>…</template></div>
  const mountLazy = (box) => {
    const tpl = box.querySelector('template');
    if (tpl) box.replaceWith(tpl.content.cloneNode(true)); else box.remove();
  };
  const ioLazy = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { ioLazy.unobserve(e.target); mountLazy(e.target); } }), { rootMargin: '700px 0px' })
    : null;
  const scanLazy = () => document.querySelectorAll('.d1-ts-lazy:not([data-d1-observed])').forEach((box) => {
    box.dataset.d1Observed = '1';
    if (ioLazy) ioLazy.observe(box); else mountLazy(box);
  });
  const scan = (root) => {
    (root || document).querySelectorAll('.d1-rating:not([data-d1-observed])').forEach((el) => {
      el.dataset.d1Observed = '1';
      if (io) io.observe(el); else fill(el);
    });
    scanLazy();
  };
  const mo = new MutationObserver(() => { clearTimeout(mo.t); mo.t = setTimeout(() => scan(), 80); });
  const start = () => { scan(); mo.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.D1Ratings = { scan, grade, fill, mountLazy };
})();
